import React, { useState, useEffect } from "react";
// Import components
import Header from "./Header";
import Footer from "./Footer";

import { Card, CardBody, Col, Container, Row } from "reactstrap";

const NonAuthLayout = ({ children }) => {
  const [theme, setTheme] = useState("light");

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  const [isLogged, setIsLogged] = useState(false);

  // const toggleLayout = () => {
  //   setIsVerticalLayout((prevLayout) => !prevLayout);
  // };

  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", theme);
  }, [theme]);

  return (
    <React.Fragment>
      <div id="layout-wrapper" className="min-vh-100 d-flex flex-column">
        <div className="main-content-sec">{children}</div>
        <Footer theme={theme} toggleTheme={toggleTheme} />
      </div>
    </React.Fragment>
  );
};

export default NonAuthLayout;
